import store from "@/state/store";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  // {
  //   path: "/register",
  //   name: "Register",
  //   component: () => import("../views/account/register.vue"),
  //   meta: {
  //     title: "Register",
  //     beforeResolve(routeTo, routeFrom, next) {
  //       // If the user is already logged in
  //       if (store.getters["auth/loggedIn"]) {
  //         // Redirect to the home page instead
  //         next({ name: "default" });
  //       } else {
  //         // Continue to the login page
  //         next();
  //       }
  //     },
  //   },
  // },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/",
    name: "dashboard",
    meta: { title: "Dashboard", authRequired: false },
    component: () => import("../pages/dashboard.vue"),
  },
  {
    path: "/otp",
    name: "otp verification",
    meta: {
      title: "OTP Verification",
    },
    component: () => import("../views/account/OTP.vue"),
  },
  {
    name: "resetPassword",
    path: "/resetpassword",
    meta: {
      title: "Reset Password",
    },
    component: () => import("../views/account/reset-password.vue"),
  },


  {
    path: "/user/profile/:id",
    name: "Profile",
    meta: {
    title: "Profile",
    authRequired: false,
    },
    component: () => import("../pages/users/Profile.vue"),
    children:[
        {
          path: "user-permission",
          name: "userpermission",
          meta: {
            title: "userpermission",
            // authRequired: true,
            // requiredPermission:'update user permission'
          },
          component: () => import("../pages/users/UserPermissions.vue"),
        },
        {
          path: "",
          name: "useroverview",
          meta: {
            title: "overview",
            // authRequired: true,
            // requiredPermission:'view users'
          },
          component: () => import("../pages/users/Overview.vue"),
        },
        {
          path: "assign-role",
          name: "Assign Role",
          meta: {
            title: "Assign Roles",
            // authRequired: true,
            // requiredPermission:'view users'
          },
          component: () => import("../pages/users/Roles.vue"),
        },
    ]
  },
  {
    path: "/settings",
    name: "settings",
    meta: { title: "Settings", authRequired: false },
    component: () => import("../pages/settings/settings.vue"),
  },
  {
    path: "/cities",
    name: "Cities",
    meta: { title: "Cities", authRequired: false },
    component: () => import("../pages/settings/cities.vue"),
  },
  {
    path: "/app-settings",
    name: "application settings",
    meta: { title: "Application Settings", authRequired: false },
    component: () => import("../pages/settings/app-settings.vue"),
  },
  {
    path: "/categories",
    name: "categories",
    meta: { title: "Categories", authRequired: false },
    component: () => import("../pages/categories/categories.vue"),
  },
  {
    path: "/categories/:id",
    name: "categories-single",
    meta: { title: "SubCategories", authRequired: false },
    component: () => import("../pages/categories/category-single.vue"),
  },
  {
    path: "/credit-sub-category/:id?",
    name: "credit sub-category",
    meta: { title: "Create SubCategory", authRequired: false },
    component: () => import("../pages/categories/credit-subcategory.vue"),
  },
  {
    path: "/edit-sub-category/:id",
    name: "edit sub-category",
    meta: { title: "Edit SubCategory", authRequired: false },
    component: () => import("../pages/categories/edit-subcategory.vue"),
  },
  {
    path: "/listings",
    name: "listings",
    meta: { title: "listings", authRequired: false },
    component: () => import("../pages/listings/listings.vue"),
  },
  {
    path: "/pending-listings",
    name: "pending-listings",
    meta: { title: "pending-listings", authRequired: false },
    component: () => import("../pages/listings/pending-listings.vue"),
  },
  {
    path: "/premium-listings",
    name: "premium-listings",
    meta: { title: "premium-listings", authRequired: false },
    component: () => import("../pages/listings/premium-listings.vue"),
  },
  {
    path: "/listings/:id",
    name: "listings view",
    meta: { title: "listings view", authRequired: false },
    component: () => import("../pages/listings/listing-view.vue"),
  },
  {
    path: "/create-listing",
    name: "listing-request",
    meta: { title: "listing Request", authRequired: false },
    component: () => import("../pages/listings/create.vue"),
  },
  {
    path: "/transactions",
    name: "transactions",
    meta: { title: "Transactions", authRequired: false },
    component: () => import("../pages/transactions/transactions.vue"),
  },
  {
    path: "/transactions-stats",
    name: "transactionsstats",
    meta: { title: "Transactions stats", authRequired: false },
    component: () => import("../pages/transactions/payment-stats.vue"),
  },
  {
    path: "/transaction-single/:id",
    name: "transaction-single",
    meta: { title: "Transactions Single", authRequired: false },
    component: () => import("../pages/transactions/transaction-single.vue"),
  },
  {
    path: "/users",
    name: "users",
    meta: { title: "Users", authRequired: false },
    component: () => import("../pages/users/users.vue"),
  },
  {
    path: "/admin",
    name: "admin",
    meta: { title: "Admin", authRequired: false },
    component: () => import("../pages/users/admin.vue"),
  },
  {
    path: "/user/:id",
    name: "user single",
    meta: { title: "User Single", authRequired: false },
    component: () => import("../pages/users/user-single.vue"),
  },
  // {
  //   path: "/kyc3-single/:id",
  //   name: "kyc3-single",
  //   meta: { title: "KYC3 single", authRequired: false },
  //   component: () => import("../pages/users/kyc/kyc3view.vue"),
  // },
  // {
  //   path: "/kyc3-requests",
  //   name: "kyc3-requests",
  //   meta: { title: "KYC3 Requests", authRequired: false },
  //   component: () => import("../pages/users/kyc3-requests.vue"),
  // },
  // {
  //   path: "/kyc2-requests",
  //   name: "kyc2-requests",
  //   meta: { title: "KYC2 Requests", authRequired: false },
  //   component: () => import("../pages/users/kyc2-requests.vue"),
  // },
  {
    path: '/auth/404',
    name: '404',
    meta: {
      title: "Error 404", authRequired: false,
    },
    component: () => import('../views/auth/errors/404')
  },
  {
    path: '/auth/403',
    name: '403',
    meta: {
      title: "Error 403", authRequired: false,
    },
    component: () => import('../views/auth/errors/403')
  },
  {
    path: '/auth/500',
    name: '500',
    meta: {
      title: "Error 500", authRequired: false,
    },
    component: () => import('../views/auth/errors/500')
  },
  {
    path: '/auth/404-basic',
    name: '404-basic',
    meta: {
      title: "Error 404", authRequired: false,
    },
    component: () => import('../views/auth/errors/404-basic')
  },
  {
    path: '/auth/404-cover',
    name: '404-cover',
    meta: {
      title: "Error 404", authRequired: false,
    },
    component: () => import('../views/auth/errors/404-cover')
  },
  {
    path: '/auth/ofline',
    name: 'ofline',
    meta: {
      title: "Offline", authRequired: false,
    },
    component: () => import('../views/auth/errors/ofline')
  },
  {
    path: '/auth/logout-basic',
    name: 'logout-basic',
    meta: {
      title: "Logout", authRequired: false,
    },
    component: () => import('../views/auth/logout/basic')
  },
  {
    path: '/auth/logout-cover',
    name: 'logout-cover',
    meta: {
      title: "Logout", authRequired: false,
    },
    component: () => import('../views/auth/logout/cover')
  },
  {
    path: "/apps",
    name: "Applications",
    meta: { title: "apps", authRequired: false },
    component: () => import("../pages/app_version/AppVersion"),
  },
  
];